/* Bloomed in Gold — minimal interactions */
(function () {
  'use strict';

  /* Reveal-on-scroll (restrained, single class) */
  const els = document.querySelectorAll('.bloom-reveal');
  if (!('IntersectionObserver' in window) || !els.length) {
    els.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Mobile nav toggle (used by header) */
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-bloom-nav-toggle]');
    if (!trigger) return;
    const nav = document.querySelector('[data-bloom-nav]');
    if (!nav) return;
    const open = nav.classList.toggle('is-open');
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
  });

  /* Smooth-scroll for in-page anchors */
  document.addEventListener('click', function (e) {
    const a = e.target.closest('a[href^="#"]');
    if (!a) return;
    const id = a.getAttribute('href');
    if (id.length < 2) return;
    const target = document.querySelector(id);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
